const additional = [
    {"key":"forms.contact.topic.placeholder", "string":"The topic of your message"},
    {"key":"forms.contact.topic.label", "string":"Topic"},
    {"key":"forms.contact.name.label", "string":"Your name"},
    {"key":"forms.contact.email.label", "string":"Your email"},
    {"key":"forms.contact.message.label", "string":"Your message"},
    {"key":"forms.contact.submit.label", "string":"Send message"},
    {"key":"forms.contact.title", "string":"Write a message to"},
    {"key":"forms.contact.sent", "string":"Your message was sent."},
    {"key":"forms.contact.close", "string":"Close dialog"},
    {"key":"filter.tags", "string":"Search for keywords"},
    {"key":"contact.button", "string":"Contact"},
    {"key":"select.country", "string":"Please select a country"},
    {"key":"results.found", "string":"results found"},
    {"key":"pages", "string":"Pages"},
    {"key":"jump.to.top", "string":"Jump to top"},
    {"key":"delete.userdata", "string":"Delete my data and account"},
    {"key":"delete.infotext", "string":"If you visited events or subscribed to the GeoPLASMA-CE newsletter on the project website, please write an email to webadmin@geoplasma-ce.eu with your full name to get information about the data that was collected and saved about you via participants lists or newsletter lists."},
    {"key":"mydata.infotext", "string":"The following data is saved about you on this website"},
    {"key":"mydata.button", "string":"My data"},
    {"key":"no.conflict.found", "string":"No conflict found for this location."},
    {"key":"tracking.button", "string":"Disable tracking via Google Analytics"},
    {"key":"button.backtomap","string":"Back to map"},{"key":"whytouse.why","string":"Why to use Shallow Geothermal Energy? "},
    {"key":"pdf.generate", "string":"Generating PDF..."},
    {"key":"area.not_finished_title", "string":"The web GIS for this area is still under construction!"},
    {"key":"area.not_finished_text1", "string":"Please visit again in the coming weeks. It won't take long anymore until you will be able to see the web GIS for this area at this place.."},
    {"key":"area.not_finished_text2", "string":"If you want to know how it will look, simply visit one of the already active ones:"},
    {"key":"webgis.outside", "string":"You clicked outside of the pilot area."},
    {
        "key": "webgis.address",
        "string": "Address:"
    },
    {"key":"homepage.local_contacts", "string":"Local contacts"},
    {"key":"homepage.communication", "string":"Communication"},
    {"key":"homepage.project_manager", "string":"Project manager"},
    {"key":"webgis.field_measurements", "string":"Field measurements"},
    {"key":"webgis.field_measurements.location", "string":"Location"},
    {"key":"webgis.field_measurements.measurements", "string":"Measurements"},
    {"key":"webgis.field_measurements_object_id", "string":"ID"},
    {"key":"webgis.field_measurements_object_type", "string":"Type"},
    {"key":"webgis.field_measurements_object_name", "string":"Name"},
    {"key":"webgis.field_measurements_utm_east", "string":"UTM east"},
    {"key":"webgis.field_measurements_utm_north", "string":"UTM north"},
    {"key":"webgis.field_measurements_utm_merid", "string":"UTM merid"},
    {"key":"webgis.field_measurements_gps_lon", "string":"GPS lon"},
    {"key":"webgis.field_measurements_gps_lat", "string":"GPS lat"},
    {"key":"webgis.field_measurements_gps_alt", "string":"GPS altitude"},
    {"key":"webgis.field_measurements_gps_alt_reference", "string":"GPS altitude reference"},
    {"key":"webgis.field_measurements_comment", "string":"Comment"},
    {"key":"webgis.field_measurements_measurements_id", "string":"ID"},
    {"key":"webgis.field_measurements_pp_number", "string":"Project partner"},
    {"key":"webgis.field_measurements_m_input_parameter_id", "string":"Input parameter"},
    {"key":"webgis.field_measurements_date_from", "string":"Date from"},
    {"key":"webgis.field_measurements_date_to", "string":"Date to"},
    {"key":"webgis.field_measurements_depth_from", "string":"Depth from"},
    {"key":"webgis.field_measurements_depth_to", "string":"Depth to"},
    {"key":"webgis.field_measurements_value_alphanum", "string":"Unit"},
    {"key":"webgis.field_measurements_value_average", "string":"Value average"},
    {"key":"webgis.field_measurements_value_min", "string":"Value min"},
    {"key":"webgis.field_measurements_value_max", "string":"Value max"},
    {"key":"webgis.field_measurements_description", "string":"Description"},
    {"key":"webgis.field_measurements_m_link_to_document", "string":"Link to document"},
    {"key":"webgis.explain", "string":"To create a location specific query, click on the map inside the pilot area."},
    {"key":"links.acronym", "string":"Acronym:"},
    {"key":"links.financing", "string":"Financing program:"},
    {"key":"links.link", "string":"Link to website:"},


    {"key":"example.title", "string":"Title:"},
    {"key":"example.address_of_project", "string":"Address of project:"},
    {"key":"example.gps_coordinates", "string":"GPS coordinates:"},
    {"key":"example.usage_form", "string":"Usage form:"},
    {"key":"example.heating_capacity", "string":"Heating capacity:"},
    {"key":"example.heating_production", "string":"Heating production:"},
    {"key":"example.cooling_capacity", "string":"Cooling capacity:"},
    {"key":"example.cooling_production", "string":"Cooling production:"},
    {"key":"example.seasonal_performance", "string":"Seasonal performance:"},
    {"key":"example.number_of_tubes_wells", "string":"Number of tubes / wells:"},
    {"key":"example.depth_of_tubes_wells", "string":"Depth of tubes / wells:"},
    {"key":"example.geothermal_coverage_rate", "string":"Geothermal coverage rate:"},
    {"key":"example.depth_of_tubes_wells", "string":"Depth of tubes / wells:"},
    {"key":"example.supply_temperature_borehole", "string":"Supply temperature borehole:"},
    {"key":"example.supply_temperature_heating", "string":"Supply temperature heating:"},
    {"key":"example.supply_temperature_cooling", "string":"Supply temperature cooling:"},
    {"key":"example.planning_company", "string":"Planning company:"},
    {"key":"example.specialties_of_project", "string":"Specialties of project:"},
    {"key":"example.drilling_company", "string":"Drilling company:"},
    {"key":"example.heating_installer", "string":"Heating installer:"},
    {"key":"example.thermal_response_test", "string":"Thermal response test:"},
    {"key":"example.year_of_installation", "string":"Year of installation:"},
    {"key":"example.web_link", "string":"Web link:"},
    {"key":"example.description", "string":"Description:"},
    {"key":"example.pilotarea_id", "string":"Pilot area:"},

    {"key":"example.teaser", "string":"Case studies from our pilot areas"},
    {"key":"links.teaser", "string":"International links"},
    {"key":"webgis.borehole.length", "string":"length"},
    {"key":"webgis.borehole.point", "string":"bore point"},
    {"key":"webgis.explanatory_notes","string":"Explanatory notes"},
    {"key":"webgis.fullprofile","string":"See full profile"}
]
export default additional



// WEBPACK FOOTER //
// ./src/i18n/en/additional/additional.js